<template>
  <div>
    <Toolbar
      :handle-submit="onSendTicketActionForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-ticket</v-icon>{{ item['ticket'].name }} - {{ $t('ticket.ticketaction') }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <TicketactionForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import TicketactionForm from '../../components/ticketaction/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'Ticketaction';

export default {
  name: 'TicketactionUpdate',
  servicePrefix,
  mixins: [UpdateMixin, FileMixin],
  components: {
    Loading,
    Toolbar,
    TicketactionForm
  },

  computed: {
    ...mapFields('ticketaction', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('ticketaction', ['find'])

  },

  methods: {
    ...mapActions('ticketaction', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),
    onSendTicketActionForm() {
      this.onSendForm();
      this.inputfile = this.item.file;
    }
  }
};
</script>
